import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";
import { Reveal, Overline } from "@/components/Reveal";
import { STATS } from "@/data/mock";

const Counter = ({ value, suffix, decimals }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!inView) return;
    let raf;
    const start = performance.now();
    const dur = 1800;
    const tick = (now) => {
      const p = Math.min((now - start) / dur, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setDisplay(value * eased);
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, value]);

  const formatted =
    decimals > 0
      ? display.toFixed(decimals)
      : Math.round(display).toLocaleString("pt-BR");

  return (
    <span ref={ref}>
      {formatted}
      <span className="text-gold-gradient">{suffix}</span>
    </span>
  );
};

export const Stats = () => (
  <section className="relative py-20 md:py-28" data-testid="stats-section">
    <div className="max-w-7xl mx-auto px-5 md:px-8">
      <Reveal className="mb-12">
        <Overline>Números da Plataforma</Overline>
        <p className="mt-3 text-white/50 max-w-lg font-body">
          Indicadores atualizados continuamente para fins informativos.
        </p>
      </Reveal>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
        {STATS.map((s, i) => (
          <Reveal key={s.id} delay={i * 0.08}>
            <div
              className="glass-gold p-6 md:p-8 h-full group hover:border-[#F5C542]/40 transition-colors duration-300"
              data-testid={`stat-${s.id}`}
            >
              <div className="font-display text-3xl md:text-5xl font-bold tracking-tighter text-white">
                <Counter
                  value={s.value}
                  suffix={s.suffix}
                  decimals={s.decimals}
                />
              </div>
              <div className="mt-3 text-xs md:text-sm tracking-wider uppercase text-white/45 font-medium">
                {s.label}
              </div>
              <div className="mt-4 h-px w-10 bg-gradient-to-r from-[#F5C542] to-transparent group-hover:w-full transition-all duration-500" />
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
